export enum ResourceType {
 Regular = 'REGULAR',
 Embeded = 'EMBEDED',
}
